// extracted by mini-css-extract-plugin
export default {"MuiLink-root":"link_MuiLink-root__vGSto","LinkGray":"link_LinkGray__6cxXy"};